import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { colors } from 'utils/colors';
import { isQuoteMedia } from 'utils/helpers';
import { translation as translationTools } from '../../Translation/tools';

// eslint-disable-next-line react/prefer-stateless-function
class StepBar extends Component {
  render() {
    const { currentStep, accountText, targetText, french, partnerName } =
      this.props;
    const language = french ? 'fr' : 'en';
    const translateEnding = isQuoteMedia(partnerName)
      ? 'PORTFOLIO_REALLOCATE_QM'
      : 'PORTFOLIO_REALLOCATE';

    return (
      <Steps>
        <Step>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <StepBubble isActive={currentStep >= 0}>1</StepBubble>
            <StepLabel>
              {translationTools[language][translateEnding].CURRENT}
            </StepLabel>
            <StepLine isActive={currentStep > 0} />
          </div>
          <StepSubLabel>{accountText}</StepSubLabel>{' '}
        </Step>
        <Step>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <StepBubble isActive={currentStep >= 1}>2</StepBubble>
            <StepLabel>
              {translationTools[language][translateEnding].TARGET}
            </StepLabel>
            <StepLine isActive={currentStep > 1} />
          </div>
          <StepSubLabel>{targetText}</StepSubLabel>
        </Step>
        <Step>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <StepBubble isActive={currentStep >= 2}>3</StepBubble>
            <StepLabel>
              {translationTools[language][translateEnding].TRADES}
            </StepLabel>
          </div>
          <StepSubLabel />
        </Step>
      </Steps>
    );
  }
}

const Steps = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Step = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: center;
`;

const StepBubble = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  width: 3rem;
  font-size: 1.14rem;
  color: ${({ isActive }) => (isActive ? 'white' : 'black')};
  border-radius 50%;
  background-color: ${({ isActive }) => (isActive ? colors.blue : 'white')};
  border: 2px solid ${({ isActive }) =>
    isActive ? colors.blue : colors.lightGrey};`;

const StepLabel = styled.div`
  display: flex;
  color: black;
  align-items: center;
  margin-left: 1rem;
`;

const StepLine = styled.div`
  display: flex;
  color: black;
  border: 1px solid
    ${({ isActive }) => (isActive ? colors.blue : colors.lightGrey)};
  height: 1px;
  width: 100px;
  align-self: center;
  margin-left: 1rem;
  margin-right: 5rem;
`;
const StepSubLabel = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  width: 220px;
  margin-top: -10px;
  padding-left: 57px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 20px;
  align-self: flex-start;
`;

StepBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  accountText: PropTypes.string,
  targetText: PropTypes.string,
  french: PropTypes.bool,
  partnerName: PropTypes.string,
};

StepBar.defaultProps = {
  accountText: '',
  targetText: '',
  french: false,
  partnerName: '',
};

export default connect((state) => ({
  french: state.Storage.language === 'fr',
  partnerName: state.Storage['partner-name'],
}))(StepBar);
